import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20and%20deep%20crimson%20gradient%20texture%20with%20soft%20light%20streaks%20and%20subtle%20paper%20grain%2C%20dark%20brown%20edges%2C%20calm%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20high%20detail%20wide%20composition&width=1600&height=700&seq=cta-subscribe-warm&orientation=landscape"
          alt="订阅每周更新 背景图"
          title="订阅黑料百科每周更新"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
      </div>

      <div className="relative w-full px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs text-white/80 backdrop-blur">
              <i className="ri-mail-send-line"></i> 每周更新提醒
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-white md:text-3xl">
              不想每天刷热榜？让我们每周给你一份清单
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/70">
              一封邮件汇总本周新增与更新的词条、话题脉络小结，不推送无关广告，随时可以退订。
            </p>
          </div>
          <div className="rounded-lg border border-white/15 bg-background-50/95 p-5 backdrop-blur md:p-6">
            <h3 className="text-sm font-semibold text-foreground-900">订阅每周更新</h3>
            <p className="mt-1 text-xs text-foreground-500">填写邮箱即可，我们不会分享你的信息。</p>
            <div className="mt-4">
              <SubscribeForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}